module.exports = __webpack_public_path__ + "static/img/guogaoxinshenbaozixun.c93f49d8.jpg";